const isProductOutOfStock = (product) => {
  return product?.product_available_qty <= 0 && !product?.offer_inactive;
};

export default isProductOutOfStock;
